// extracted by mini-css-extract-plugin
export default {"container":"openEditorContent_container__m-215"};